import { gql } from 'apollo-angular';

export const GET_INSTANCE_CONFIG = gql`
  query GetInstanceConfig {
    instanceConfig {
      stripeEnabled
      defaultTrialDays
      paymentsAddonPurchasable
      paymentsAddonAmount
      paymentsAddonCurrency
      paymentsIncludedInPlan
      availablePaymentProcessors
      bookingPackSize
      bookingPackMessages
      bookingPackAmount
      bookingPackCurrency
    }
  }
`;

export const GET_MY_SUBSCRIPTION = gql`
  query GetMySubscription {
    mySubscription {
      planName
      tierCode
      status
      gateway
      staff {
        used
        limit
        unlimited
      }
      bookings {
        used
        limit
        unlimited
      }
      bookingsTopUp
      bookingAppointments
      messages {
        used
        limit
        unlimited
      }
      messagesTopUp
      smsMessages
      whatsAppMessages
      viberMessages
      promoMessages
      promoCost
      currentPeriodStart
      currentPeriodEnd
      cancelAtPeriodEnd
    }
  }
`;

export const GET_SUBSCRIPTION_PLANS = gql`
  query GetSubscriptionPlans {
    subscriptionPlans {
      id
      name
      description
      amount
      interval
      trialPeriodDays
      details
      published
      popular
      maxTeamMembers
      maxBookingsPerMonth
      maxSmsPerMonth
      tierCode
      featuresList
    }
  }
`;

export const GET_BILLING_HISTORY = gql`
  query GetBillingHistory($limit: Int, $startingAfter: String) {
    billingHistory(limit: $limit, startingAfter: $startingAfter) {
      invoices {
        id
        number
        status
        amountDue
        amountPaid
        currency
        periodStart
        periodEnd
        invoicePdfUrl
        created
      }
      hasMore
    }
  }
`;
